import {EventBus, EventBusEvents} from "./event-bus"
import {constants} from "../constants";
import {toast} from "react-toastify";

const isProd = false;

type Response = {
  mode : string,
  data : string
}

class Api {
  constructor() {

  }

  public static getSettings = async () => {
    try {
      let resp = await fetch(constants.url.SETTINGS_URL, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      });

      return await resp.json()
    } catch (e) {
      return null
    }
  }

  public static dispatchSettingsEvent = () => {
      this.getSettings().then((settings) => {
        if (settings) {
          EventBus.getInstance().dispatch(EventBusEvents.settingsUpdated, settings)
          EventBus.getInstance().dispatch(EventBusEvents.loggedIn)
        } else {
          EventBus.getInstance().dispatch(EventBusEvents.loggedOut)
        }
      })
  }

  public static dispatchSignOutEvent = (redirectURL : string) => {
    fetch(constants.url.SIGN_OUT_URL).then(() => {
      EventBus.getInstance().dispatch(EventBusEvents.loggedOut, redirectURL)
    })
  }

  public static async isAuth() {
    let settings = await this.getSettings();
    return !!settings
  }
}

export const funcToastifyHandler = async (fn : any, catchErrString : string) => {
  let res : any = null
  try {
    res = await fn()
    let json = await res.json()
    if (json.error) {
      toast.error(json.error, {position: "top-right", autoClose: 3000, theme: "light"});
    } else if (json.message) {
      toast.success(json.message, {
        position: "top-right", autoClose: 1500, theme: "light",
      })
    }
  } catch (e) {
    toast.error(catchErrString, {position: "top-right", autoClose: 1500, theme: "light"});
  }
}

export default Api
